import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { OwnIDInit } from '@ownid/react';


const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
    <React.StrictMode>
        <OwnIDInit config={{ appId: "kojewxgifr64bo" }}/>
        <App />
    </React.StrictMode>
);